import * as types from '../constants';
import { STATUS } from '../constants';
import { reject, resolve } from '../api';

export const initialSubscriptionState = {
  status: STATUS.IDLE,
  extendSubscriptionConfirmationStatus: STATUS.IDLE,
  error: null,
};

export default (state = initialSubscriptionState, action) => {
  switch (action?.type) {
    case types.CONFIRM_EXTEND_SUBSCRIPTION:
      return {
        ...state,
        extendSubscriptionConfirmationStatus: STATUS.LOADING,
      };
    case resolve(types.CONFIRM_EXTEND_SUBSCRIPTION):
      return {
        ...state,
        extendSubscriptionConfirmationStatus: STATUS.SUCCESS,
        new_expiration_date: action?.payload?.new_expiration_date,
        error: null,
      };
    case reject(types.CONFIRM_EXTEND_SUBSCRIPTION):
      return {
        ...state,
        error: true,
        extendSubscriptionConfirmationStatus: STATUS.ERROR,
      };
    default:
      return state;
  }
};
